import { render, staticRenderFns } from "./DictMobile.vue?vue&type=template&id=365270c7&scoped=true"
import script from "./DictMobile.vue?vue&type=script&lang=js"
export * from "./DictMobile.vue?vue&type=script&lang=js"
import style0 from "./DictMobile.vue?vue&type=style&index=0&id=365270c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365270c7",
  null
  
)

export default component.exports